import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
// api
import { createAwardWinningBook } from 'api/company';
// components
import Title from 'components/backoffice/texts/title';
import AwardWinningBookForm from 'components/backoffice/forms/awardWinningBookForm';

const CreateAwardWinningBook = () => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext();

  const award = {
    nombre: '',
    year: '',
    producto_ids: []
  };

  useEffect(() => {
    setTitle(t('createAwardWinningBook'));
    return () => {
      setTitle('');
    };
  }, [setTitle, t]);

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      nombre: values.nombre,
      year: values.year,
      producto_ids: values.products.map((item) => item.id),
    };
    try {
      const { status } = await createAwardWinningBook(data);
      if (status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/award-winning-books', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      toast.error(t('mensajeerror'), { theme: 'colored' });
    }
    setLoading(false);
  }, [t, navigate]);

  return (
    <div className="award-winning-book-create mt-5">
      <Title text={t('createAwardWinningBook')} />
      <AwardWinningBookForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={award}
        beforeTitle={t('createAwardWinningBook')}
      />
    </div>
  );
};

export default CreateAwardWinningBook;